
import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";

interface GroupsHeaderProps {
  onAddGroup: () => void;
}

const GroupsHeader = ({ onAddGroup }: GroupsHeaderProps) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <h1 className="page-title">Groups</h1>
      <Button 
        className="bg-blue-500 hover:bg-blue-600"
        onClick={onAddGroup}
      >
        <PlusCircle className="mr-2 h-4 w-4" />
        Add Group
      </Button>
    </div>
  );
};

export default GroupsHeader;
